import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class AcLedgerService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 2787
     * @datataskName sp_ws_p2_w_acledger_get
     * @param params argtype and argvalue of acledger to get.
     * @returns promise containing page get of acledger.
     */
    public async getAcledger(params: GetAcledgerParams): Promise<AcLedgerGet> {
        return (await this.datatask.Post(2787, params))[0];
    }

    /**
     * @datatask 2785
     * @datataskName sp_ws_p2_w_acledgerview_get
     * @returns promise containing page get of acledgerview
     */
    public async getAcLedgerView(): Promise<AcLedgerViewGet> {
        return (await this.datatask.Post(2785))[0];
    }
}

export interface GetAcledgerParams {
    argtype: string;
    argvalue: string;
}

export interface AcLedgerGet {
    acledger_keyno: string;
    view_id: string;
    heading_acsupptrans: string;
    heading_accusttrans: string;
    heading_acledger: string;
    nbr_of_acsupptrans: string;
    nbr_of_accusttrans: string;
    argtype: string;
    argvalue: string;
    page_heading: string;
}

export interface AcLedgerViewGet {
    businessco_no: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
    account_nos?: { item_id: number; item_name: string }[];
    show_account_saldo: '1' | '0';
}
